import { Dispatch, FC, SetStateAction } from 'react';
import classes from './styles.module.scss';
import { IInfrastructureProject } from '../../../types/project.types';
import { MinusIcon, PlusBigIcon } from '../../../assets/icons';
import { useTranslation } from 'react-i18next';
import { convertFilesToImageDate } from '../../../helpers/utils';
import Documentation from '../components/documentation.component';
import ImageGrid from '../components/image-grid.component';
import AdditionalFields from '../components/additional-fields.component';

interface IProps {
    list: IInfrastructureProject[];
    isOpen: Record<string, boolean>;
    setIsOpen: Dispatch<SetStateAction<Record<string, boolean>>>;
}

const translationKey = 'projects.infrastructure-projects.culture';
const baseTranslationKey = 'projects.infrastructure-projects';

const CultureTab: FC<IProps> = ({ list, isOpen, setIsOpen }) => {
    const { t, i18n: { language } } = useTranslation();
    const suffix = language === 'ru' ? 'Ru' : 'Kz';

    const renderFieldRowItem = (labelKey: string, value: string | number | undefined, unit?: string) => (
        <div className={classes['field-row__item']}>
            <span className={classes['field-row__label']}>{t(labelKey)}:</span>
            <span className={classes['field-row__value']}>
                {value} {unit || ''}
            </span>
        </div>
    );

    const renderRequirementsBlock = (item: IInfrastructureProject) => {
        if (!item.repairRequired) return null;

        const isNeeded = item.repairRequired.toString() === 'true';
        if (!isNeeded) return null;
        return (
            <>
                <div className={classes['field-block']}>
                    <div className={classes['field-block__title']}>
                        {t(`${baseTranslationKey}.renovation`)}
                    </div>
                </div>

                {isNeeded ? <Documentation data={item} /> : null}
            </>

        );
    };

    return (
        <div className={classes['items-list']}>
            {list.map(item => (
                <div key={item.id} className={classes['project-item']}>
                    <div
                        className={classes['project-item__header']}
                        onClick={() =>
                            setIsOpen(prev => ({ ...prev, [`CULTURE-${item.id}`]: !prev[`CULTURE-${item.id}`] }))
                        }
                    >
                        <div className={classes['project-item__icon']}>
                            {isOpen[`CULTURE-${item.id}`] ? <MinusIcon /> : <PlusBigIcon />}
                        </div>
                        <span className={classes['project-item__title']}>
                            {item[`name${suffix}`] ?? '-'}
                        </span>
                        {item.constructionYear && <div className={classes['project-item__year']}>
                            <span>{t(`${translationKey}.constructionYear`)}: </span>
                            <span>{item.constructionYear ?? ''}</span>
                        </div>}
                    </div>

                    {isOpen[`CULTURE-${item.id}`] && (
                        <div className={classes['project-item__body']}>
                            <div className={classes['field-row']}>
                                {['constructionYear', 'factInfo', 'power'].map(field => {
                                    const value = item[field as keyof IInfrastructureProject] as string | number | undefined;
                                    const unit =
                                        field === 'constructionYear'
                                            ? ''
                                            : t(`people`)
                                    return renderFieldRowItem(`${translationKey}.${field}`, value, unit);
                                })}

                                {renderFieldRowItem(
                                    `${translationKey}.factCondition`,
                                    t(`${baseTranslationKey}.${item.factCondition?.toLowerCase()}`)
                                )}

                            </div>

                            {renderRequirementsBlock(item)}
                            {item.additionalFields && <AdditionalFields data={item.additionalFields} />}
                            {item.files && <ImageGrid images={convertFilesToImageDate(item.files)} />}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default CultureTab;
